import { Image, Modal } from "antd";
import React from "react";

const ProjectModal = ({
  title = "Project",
  images = [],
  description,
  techStack,
  projectModalOpen,
  setProjectModalOpen,
}) => {
  return (
    <>
      <Modal
        maskClosable
        title={<span className="text-xl font-bold">{title}</span>}
        open={projectModalOpen}
        onCancel={() => setProjectModalOpen(false)}
        className="custom-fullscreen-modal"
        footer={null}
        width="100vw"
        style={{ top: 0, height: "100vh" }}
        bodyStyle={{
          padding: "24px",
          height: "calc(100% - 55px)",
          overflow: "auto",
        }}
      >
        <div className="mx-auto max-w-7xl">
          {/* Project Description */}
          <div className="mb-6">
            <h3 className="mb-2 text-lg font-semibold text-gray-800">Overview</h3>
            <p className="text-base leading-relaxed text-justify text-gray-600 text-wrap">
              {description ||
                "I will soon share more details about this project, including a live demo link and the source code. Thank you for exploring my portfolio."}
            </p>
          </div>

          {/* Tech Stack Section */}
          {techStack && (
            <div className="mb-8">
              <h3 className="mb-2 text-lg font-semibold text-gray-800">Technology Stack</h3>
              <div className="p-3 border border-gray-100 rounded-lg bg-gray-50">
                <p className="font-mono text-sm text-gray-700">{techStack}</p>
              </div>
            </div>
          )}

          {/* Image Gallery */}
          {images.length > 0 && (
            <div className="mt-8">
              <h3 className="mb-4 text-lg font-semibold text-gray-800">Project Gallery</h3>
              {/* Changed to Grid to fix spacing issues */}
              <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
                {images.map((image, index) => (
                  <div key={index} className="w-full h-full overflow-hidden transition-all duration-300 bg-gray-100 rounded-lg shadow-md hover:shadow-xl">
                    <Image
                      src={image}
                      alt={`Project screenshot ${index + 1}`}
                      className="object-cover w-full h-full min-h-[200px]"
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    />
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </Modal> 

      <style jsx>{`
        .custom-fullscreen-modal .ant-modal-content {
          height: 100vh;
          border-radius: 0;
        }
        .custom-fullscreen-modal .ant-modal-header {
          padding: 16px 24px;
        }
      `}</style>
    </>
  );
};

export default ProjectModal;